<div class="dashboard-container">
  <div class="left-main-content">
    <!-- Row 1: Chart View / Data View toggle + global filters (insights header style) -->
    <div class="tab-container insights-header-bar" [ngClass]="{'extra-padding': !_tableViewFlag()}">
      <!-- View selector: single pill with Chart View / Data View -->
      <div class="view-selector-pill">
        <div class="tab" [class.active]="activeTab === 'visualization' && !_tableViewFlag()" (click)="showTab('visualization'); showChartView()">{{dashboard.chart_view}}</div>
        <div class="tab" [class.active]="activeTab === 'tabular' && _tableViewFlag()" (click)="showTab('tabular'); showDataView()">{{dashboard.data_view}}</div>
      </div>

      <div class="right-content">
        <filter-section [buttonTitle]="dashboard.filter" *ngIf="!hasSelectedRows()"></filter-section>
        <ng-template #container *ngIf="!hasSelectedRows()"></ng-template>
        <timezone *ngIf="!hasSelectedRows()"></timezone>
        <manage-columns *ngIf="_tableViewFlag() && !hasSelectedRows()" [buttonTitle]="dashboard.manage_column"></manage-columns>
        <app-search-dropdown *ngIf="_tableViewFlag() && !hasSelectedRows()"></app-search-dropdown>
        <more-drop-down *ngIf="_tableViewFlag() && !hasSelectedRows()"
          (dashboardOptionClicked)="onDashboardOptionsClick($event)"></more-drop-down>

        <button *ngIf="_tableViewFlag() && hasSelectedRows()" class="playground-btn-header"
          (click)="openInPlayground()">
          <img src="assets/icons/export_control_point.svg" alt="export_control_point">
          <span>Create Dataset</span>
        </button>
      </div>
    </div>

    <!-- Row 2: KPI cards (Total Conversations, Primary Topics, etc.) -->
    <conversation-overview></conversation-overview>

    <!-- Row 3: Chart grid or table view -->
    <div class="raw-table-view" *ngIf="_tableViewFlag() && !columnLoading">
      <app-tabular-view></app-tabular-view>
    </div>

    <div class="explorer-view" *ngIf="!_tableViewFlag()">
      <app-data-explorer [chatBoxVisibilityFlag]="isChatBoxVisible"></app-data-explorer>
    </div>
  </div>
  <div class="chatbox-main-container">
    <app-right-sidebar (valueChange)="onValueChange($event)"></app-right-sidebar>
  </div>
</div>
